import { getDetailedErrorMessage } from "../../utils/validation";
export class SSPsFetchFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SSPsFetchFailed);
        }
        this.name = "SSPsFetchFailed";
        this.message = `Failed to fetch SSP(s). ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map